import { useCallback, useEffect } from 'react';

import { useTrackingVisitor } from '@xing-com/crate-entity-pages-common';
import { trackPageDetail } from '@xing-com/crate-entity-pages-common/tracking';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

export const useTrackSubpage = (pageSlug: string) => {
  const { pageContext } = usePageContext();
  const { trackVisitor } = useTrackingVisitor({ pageSlug });

  useEffect(() => {
    trackVisitor();
  }, []);

  return useCallback((pageType: string) => {
    trackPageDetail({
      pageId: pageContext.pageId.split('.')[0],
      subpage: pageType,
      isEditor: pageContext.isEditor,
      focusType: pageContext.focusType,
      contractType: pageContext.contractType,
      isFollowing: !!pageContext.isFollowingPage,
    });

    return;
  }, []);
};
